/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Card, CreateTeams, List } from '.';
import { ARMcontext } from '../../utils/context/context';
import { useInputValue } from '../../utils/hooks/useInputValue';
import { TeamsContainer, ButtonWrapper, FilterWrapper, TeamsTitle } from './styles';
import { Route, Routes, useLocation, useNavigate, useParams, BrowserRouter } from 'react-router-dom';
import { Navbar, FiltersContainer, SimpleTabs, InputComponent, LargeButton, Modal, VideoTourModal } from '../../components';
import { Teams } from '../../utils/api';
import { TeamDataResponse } from '../../interfaces/Results';
import { TeamsCacheKey } from '../../utils/constants/keyCache';

const DefaultTabs = [
  {
    title: 'Cards',
    url: 'card',
    icon: 'card',
    action: () => {
      // console.log('Previous');
    },
  },
  {
    title: 'List',
    url: 'list',
    icon: 'list',
    action: () => {
      // console.log('Baseline');
    },
  },
];

const availableUrls = DefaultTabs.map((el) => `/teams/${el.url}`);

export default () => {
  const { teamMemo, AddNewTeams, user, HandleUser } = useContext(ARMcontext);
  const [isVideoTour, setVideoTour] = useState(false);
  const filterTeams = useInputValue('', 'search');
  const [modal, useModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const Team = new Teams();

  useEffect(() => {
    if (!availableUrls.find((el) => el === location.pathname)) {
      navigate('/teams/card');
      return;
    }
    if (user.data.isFirstLogin) {
      setVideoTour(true);
      if(user.role === 'org-admin'){
        navigate('/', { replace: true });
      }
    }
    FetchTeams();
  }, [location.pathname]);

  function HandleEditTeam(value = !modal) {
    useModal(value);
    if (!value) {
      FetchTeams(false);
    }
  }

  async function FetchTeams(isCachable = true): Promise<void> {
    let res: TeamDataResponse;
    if(isCachable){
      res = await Team.ExecuteCacheRequest({
        cacheKey: TeamsCacheKey,
        queryFn: Team.GetMyTeams,
      });
    } else {
      res = await Team.ExecuteCacheRequest({
        isForceDelete: true,
        cacheKey: TeamsCacheKey,
        queryFn: Team.GetMyTeams,
      });
    }
    const allValues = {
      primaryPositions: {
        pitchers: res?.data?.meta?.players?.all?.pitchers,
        catchers: res?.data?.meta?.players?.all?.catchers,
        infielders: res?.data?.meta?.players?.all?.infielders,
        outfielders: res?.data?.meta?.players?.all?.outfielders,
      },
      pitchers: res?.data?.meta?.players?.all?.pitchers,
      catchers: res?.data?.meta?.players?.all?.catchers,
      infielders: res?.data?.meta?.players?.all?.infielders,
      outfielders: res?.data?.meta?.players?.all?.outfielders,
    };
    const AllPlayers = {
      ...allValues,
      age: [],
      color: '#007AFF',
      badge: 'ALL',
      name: 'All Players',
      organizationName: 'ARM CARE',
      totalPlayers: res?.data?.meta?.players?.total,
      __name: 'All Players',
      __organization: 'ARM CARE',
      __organizationToStr: 'ARM CARE',
    };

    AddNewTeams([AllPlayers, ...res?.data?.teams]);
  }

  async function handleVideoTour(): Promise<void> {
    setVideoTour(false)
    let data = JSON.parse(JSON.stringify(user));
    data['data']['isFirstLogin'] = false;
    HandleUser(data)
    Team.SetFirstLogin();
  }

  return (
    <>
      {isVideoTour && (
        <VideoTourModal callback={handleVideoTour} />
      )}
      <Navbar />
      <FiltersContainer>
        <TeamsContainer data-cy="teams-option">
          <TeamsTitle>
            <span>Teams</span>
          </TeamsTitle>
          <div>
            <SimpleTabs dataArray={DefaultTabs} url={'/teams'} dcolor="#CBCFDD" xmargin="3px" textTransform="none" />
          </div>
          <FilterWrapper>
            {user.role === 'org-admin' || user.data.isAdmin ? (
              <>
                <InputComponent dynamicSearch={filterTeams} animateWidth="30%" placeholder="Search" maxLength={70} responsive="500px" />
                <ButtonWrapper>
                  <LargeButton
                    title="ADD A NEW TEAM"
                    lColor="var(--SecondaryBlue);"
                    rColor="var(--PrimaryBlue);"
                    icon="plus"
                    callback={HandleEditTeam}
                    dataCy="create-team"
                    responsive="500px"
                  />
                </ButtonWrapper>
              </>
            ) : (
              <InputComponent dynamicSearch={filterTeams} animateWidth="50%" placeholder="Search" />
            )}
          </FilterWrapper>
        </TeamsContainer>
      </FiltersContainer>
      <Routes>
        <Route path={':teamsId'} element={<TeamsRouter teamMemo={teamMemo} inputValue={filterTeams} />}>

        </Route>
      </Routes>
      {modal && (
        <Modal title="New team" margin="12vh auto 200px auto" dataCy="modal-create-team">
          <CreateTeams HandleEditTeam={HandleEditTeam} />
        </Modal>
      )}
    </>
  );
};

const TeamsRouter = ({ teamMemo, inputValue }) => {
  const { teamsId } = useParams() as any;

  return (
    <>
      {teamsId === 'card' ? (
        <Card teamMemo={teamMemo} inputValue={inputValue} />
      ) : teamsId === 'list' ? (
        <List teamMemo={teamMemo} inputValue={inputValue} />
      ) : (
        <></>
      )}
    </>
  );
};
